import { render, staticRenderFns } from "./DonationMonthlyStatusTag.vue?vue&type=template&id=53a51a88&scoped=true&"
import script from "./DonationMonthlyStatusTag.vue?vue&type=script&lang=ts&"
export * from "./DonationMonthlyStatusTag.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53a51a88",
  null
  
)

export default component.exports